import React from 'react';
import { motion } from 'framer-motion';
import { FileText, ChartLineUp, ChatCircleDots } from '@phosphor-icons/react';

const cards = [
  {
    icon: FileText,
    title: 'Documents',
    description: 'Upload reports, scans, or letters. I can read and reference them.',
  },
  {
    icon: ChartLineUp,
    title: 'Daily check-ins',
    description: 'Even 30 seconds a day builds a picture over time.',
  },
  {
    icon: ChatCircleDots,
    title: 'Chat',
    description: 'Talk to me anytime. I remember what you share.',
  },
];

export const OnboardingDataAwareness = () => {
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-6">
      {/* Kindra message */}
      <div className="bg-white border border-slate-150 rounded-2xl p-5">
        <p className="text-slate-700 leading-relaxed font-medium">
          You're all set. A few things to know:
        </p>
      </div>

      {/* Info cards */}
      <div className="space-y-3">
        {cards.map(({ icon: Icon, title, description }) => (
          <motion.div
            key={title}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: cards.indexOf(cards.find(c => c.title === title)) * 0.1 }}
            className="bg-white border border-slate-200 rounded-xl p-4 flex items-start gap-4"
          >
            <div className="w-10 h-10 rounded-full bg-[#235347]/10 flex items-center justify-center flex-shrink-0">
              <Icon size={20} className="text-[#235347]" />
            </div>
            <div>
              <p className="text-sm font-medium text-slate-900">{title}</p>
              <p className="text-sm text-slate-500 mt-0.5">{description}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <p className="text-sm text-slate-500 leading-relaxed">
        The more data I have, the more useful I become — but go at your own pace.
      </p>
    </motion.div>
  );
};
